export default __webpack_public_path__ + "static/media/lv12.3bee77a1.png";